import React from 'react';
//import fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCog, faGift, faUsers, faFileAlt, faKey, faTags, faPencilAlt, faChartBar, faChartLine, faUserFriends, faPenClip } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { useGlobalContext } from '../../GlobalContext';

function SideBar() {
    const {
        appUser, setAppUser, setIsLogin, setIsLogoutRequest
    } = useGlobalContext();

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("oojwt");
        setIsLogin(false);
        setAppUser(null);
        setIsLogoutRequest(true);
        navigate('/login');
    };

    const isFreeUser = appUser?.status === 'free';
    const isActiveUser = appUser?.status === 'active';

    return (
        <>
            <aside id='sidebar' className='sidebar'>
                <ul className='sidebar-nav' id='sidebar-nav'>
                    {/* If user is free, only show Blog View */}
                    {isFreeUser && (
                        <>
                            <li className='nav-item'>
                                <Link className='nav-link' to='/'>
                                    <i><FontAwesomeIcon icon={faHome} /></i>
                                    <span>Dashboard</span>
                                </Link>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link collapsed' data-bs-target="#blog-nav" data-bs-toggle="collapse" to='#'>
                                    <i><FontAwesomeIcon icon={faPencilAlt} /></i>
                                    <span>Blog</span>
                                    <i className='bi bi-chevron-down ms-auto'></i>
                                </Link>
                                <ul id='blog-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                                    <li>
                                        <Link to='/blog/list/grid'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>View</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link' onClick={handleLogout} >
                                    <i className='bi bi-lock'></i>
                                    <span>Sign Out</span>
                                </Link>
                            </li>
                        </>
                    )}


                    {/* If user is active, show all menus */}
                    {isActiveUser && (
                        <>
                            <li className='nav-item'>
                                <Link className='nav-link' to='/'>
                                    <i><FontAwesomeIcon icon={faHome} /></i>
                                    <span>Dashboard</span>
                                </Link>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link' to='/epinpurchase/list'>
                                    <i><FontAwesomeIcon icon={faPenClip} /></i>
                                    <span>My Epins Purchase</span>
                                </Link>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link collapsed' data-bs-target="#brand-officer-nav" data-bs-toggle="collapse" to='#'>
                                    <i><FontAwesomeIcon icon={faUsers} /></i>
                                    <span>Members</span>
                                    <i className='bi bi-chevron-down ms-auto'></i>
                                </Link>
                                <ul id='brand-officer-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                                    <li>
                                        <Link to='/members/add'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>Add</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/members/list/free'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>Free Members</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/members/list'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>Active Members</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/members/list/inactive'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>In-Active Members</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link collapsed' data-bs-target="#epin-purchase-nav" data-bs-toggle="collapse" to='#'>
                                    <i><FontAwesomeIcon icon={faLayerGroup} /></i>
                                    <span>Member Epins</span>
                                    <i className='bi bi-chevron-down ms-auto'></i>
                                </Link>
                                <ul id='epin-purchase-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                                    {appUser?.canCreateEpin == 1 && (
                                        <li>
                                            <Link to='/epinpurchase/add'>
                                                <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                                <span>Add</span>
                                            </Link>
                                        </li>
                                    )}
                                    <li>
                                        <Link to='/epinpurchase/members/list'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>Search</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link collapsed' data-bs-target="#blog-nav" data-bs-toggle="collapse" to='#'>
                                    <i><FontAwesomeIcon icon={faPencilAlt} /></i>
                                    <span>Blog</span>
                                    <i className='bi bi-chevron-down ms-auto'></i>
                                </Link>
                                <ul id='blog-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                                    {appUser?.canCreateBlog == 1 && (
                                        <li>
                                            <Link to='/blog/add'>
                                                <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                                <span>Add</span>
                                            </Link>
                                        </li>
                                    )}
                                    <li>
                                        <Link to='/blog/list/grid'>
                                            <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                            <span>View</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className='nav-item'>
                                <Link className='nav-link' to='/page/list'>
                                    <i><FontAwesomeIcon icon={faFileAlt} /></i>
                                    <span>Information</span>
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link className='nav-link' to='/mystatus'>
                                    <i><FontAwesomeIcon icon={faChartLine} /></i>
                                    <span>My Status</span>
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link className='nav-link' to='/myrefer'>
                                    <i><FontAwesomeIcon icon={faUserFriends} /></i>
                                    <span>My Refer</span>
                                </Link>
                            </li>
                            <hr />
                            <li className='nav-item'>
                                <Link className='nav-link' to='/myprofile'>
                                    <i className='bi bi-person'></i>
                                    <span>My Profile</span>
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link className='nav-link' to='/mypassword'>
                                    <i className='bi bi-key'></i>
                                    <span>My Password</span>
                                </Link>
                            </li>
                            <li className='nav-item'>
                                <Link className='nav-link' onClick={handleLogout} >
                                    <i className='bi bi-lock'></i>
                                    <span>Sign Out</span>
                                </Link>
                            </li>
                        </>
                    )}
                </ul>
            </aside>
        </>
    );
}

export default SideBar;
